import React from "react";

import {Button, Card, Col, Container, Modal, Row, Table} from "reactstrap";
import {Redirect} from "react-router-dom";
import ScheduleHeader from "../../components/Headers/ScheduleHeader";
import Schedule from "../../components/Schedule/Schedule";
import DayPreview from "../../components/Schedule/DayPreview";
import dateHelpers from "../../helpers/DateHelper";
import {isMobile} from 'react-device-detect';
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import ResourceApiService from "../../api/resource-api-service";
import {common_strings} from "../../translations/common_translations";
import resourceHelper from "../../helpers/ResourceHelper";
import EditClassTypeView from "../../components/Resources/EditClassTypeView";
import ErrorModal from "../../components/Alerts/ErrorModal";
import AddClassModal from "../../components/Schedule/AddClassModal";
import AddOneClassModal from "../../components/Schedule/AddOneClassModal";
import EditEventModal from "../../components/Schedule/EditEventModal";
import {report_strings} from "../../translations/report_translations";
import CheckBoxList from "../../components/Tables/CheckBoxList";
import lsHelpers from "../../helpers/LsHelper";
import businessHelper from "../../helpers/BusinessHelper";
import WeekSchedule from "../../components/Schedule/WeekSchedule";
import reportApiService from "../../api/report-api-service";
import CopyClassesControls from "../../components/Schedule/CopyClassesControls";
import SupportModal from "../../components/Alerts/SupportModal";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);
let reportStrings = new LocalizedStrings(report_strings);

class StudioSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subUser: businessHelper.subUser(),
            loading: false,
            events: null,
            monthShift: 0,
            selectedDay: null,
            showDayPreview: false,
            classTypes: null,
            rooms: null,
            teachers: null,
            showClassTypes: null,
            updateSchedule: false,
            updateDayPreview: false,
            error: null,
            showError: false,
            showRegModal: false,
            dayViewUpdatedTimes: 0,
            showEventModal: false,
            selectedEvent: null,
            showFilters: false,
            viewChanged: false,
            shouldShowWidget: false,
            shouldShowRequestWidget: false,
            filters: {
                teachers: null,
                rooms: null,
            }
        };
    }

    onDaySelected = this.onDaySelected.bind(this);
    closeDayPreview = this.closeDayPreview.bind(this);
    goToClass = this.goToClass.bind(this);
    openEvent = this.openEvent.bind(this);
    showClassTypes = this.showClassTypes.bind(this);
    getTeachersAndRooms = this.getTeachersAndRooms.bind(this);
    editClassAction = this.editClassAction.bind(this);
    closeEditClassView = this.closeEditClassView.bind(this);
    createNewClassType = this.createNewClassType.bind(this);
    closeEditClassTypeView = this.closeEditClassTypeView.bind(this);
    handleClassesAdded = this.handleClassesAdded.bind(this);
    onShiftChange = this.onShiftChange.bind(this);
    toggleOneClassModal = this.toggleOneClassModal.bind(this);
    createClassNewClassType = this.createClassNewClassType.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.dayShift !== nextState.dayShift) {
            this.getTodayEvents(nextState.dayShift)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.updateSchedule === true) {
            this.setState({
                updateSchedule: false,
                updateDayPreview: false
            })
        }

        if (prevState.filters !== this.state.filters) {
            this.setState({updateSchedule: true})
        }
    }

    anotherDayEvents(e, val) {
        this.setState(prevState => {
            return {dayShift: prevState.dayShift + val}
        });

        e.preventDefault()
    }

    resetShift(e) {
        this.setState(prevState => {
            return {dayShift: 0}
        });

        e.preventDefault()
    }

    refreshDayView = () =>
        this.setState({refreshDayView: !this.state.refreshDayView});

    getTodayEvents(shift = 0) {
        this.setState({isLoading: true});
    }

    componentDidMount() {
        reportApiService.ahoy("schedule_view")

        const script = document.createElement('script');
        script.src = 'https://app.openmanagerapp.com/schedule_app_scrpt.js';
        document.head.appendChild(script);

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
        }
    }

    filtersAreOn() {
        return (this.state.filters.teachers !== null && this.state.filters.teachers.length > 0) ||
            (this.state.filters.rooms !== null && this.state.filters.rooms.length > 0)
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index
        });

        this.getAttendanceStats(index === 1 ? "month" : "week")
    };

    toggleSupportModal = () => {
        this.setState({shouldShowRequestWidget: !this.state.shouldShowRequestWidget})
    };

    render() {
        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            lsHelpers.logout()
            return <Redirect from="*" to="/auth/login"/>
        }

        this.localize();

        if (isMobile) {
            // alert("is is mobile")
        }
        if (this.state.goToClass === true && this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }
        if (this.state.showDayPreview === true) {
            // window.scrollTo(0, this.dayViewRef.offsetTop);
        }

        if (this.state.showClassTypeEditor === true) {
            // window.scrollTo(0, this.classTypeViewRef.offsetTop);
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }
        return (
            <>
                {this.state.showFilters &&
                this.renderFilterModal()
                }

                {this.state.shouldShowRequestWidget &&
                    <SupportModal toggleModal={this.toggleSupportModal} prefilledTitle={resourceStrings.schedule_widget} prefilledMessage={resourceStrings.request_widget_message}/>
                }

                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={() => this.toggleErrorModal()}/>
                }

                {this.state.showRegModal === true &&
                <AddClassModal toggleModal={() => this.toggleClassesModal()} classTypes={this.state.classTypes}
                               handleClassesAdded={this.handleClassesAdded}
                               handleError={() => this.handleNetworkError()}
                               shift={this.state.monthShift}
                />
                }

                {this.state.showEventModal === true &&
                <EditEventModal toggleModal={() => this.toggleEventModal()} event={this.state.selectedEvent}
                                handleEventSaved={this.handleClassesAdded} handleError={() => this.handleNetworkError()}
                />
                }

                {this.state.showCopyControls &&
                <CopyClassesControls toggleModal={() => this.toggleCopyModal()}
                                     handleError={() => this.handleNetworkError()}
                                     reloadSchedule={this.reloadSchedule.bind(this)}
                />
                }

                {this.state.showClassEditor === true &&
                this.renderAddClassPopup()
                }

                <ScheduleHeader addClass={this.showClassTypes} addRegClasses={() => this.showRegClassesModal()}
                                addEvent={this.showEventModal.bind(this)}
                                addReminder={this.showReminderModal.bind(this)}
                                showFilters={this.showFilters.bind(this)}
                                showCopyClasses={this.showCopyClasses.bind(this)}
                                filtersAreOn={this.filtersAreOn()}
                                weekView={this.weekView.bind(this)}
                                monthView={this.monthView.bind(this)}
                                showWidget={this.showWidget.bind(this)}
                />
                {this.state.shouldShowWidget &&
                <div>
                    <h3 style={{margin: 20}}>{resourceStrings.schedule_widget} <Button
                        size="sm"
                        style={{marginLeft: 10}}
                        color="warning"
                        onClick={e => this.toggleSupportModal(e)}
                    >
                        {resourceStrings.request_widget}
                    </Button></h3>
                    <label style={{marginLeft: 20, marginBottom: 10}}>{resourceStrings.schedule_widget_expl}</label>
                    <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}}><img
                        style={{width: "90%"}}
                        alt="..."
                        src={require("assets/img/schedule/Screenshot 2023-06-16 at 15.51.35.png")}
                    /></div>


                </div>
                }
                {!this.state.shouldShowWidget &&
                    <Container className="mt-150" fluid>
                        <Row className="mt-3">
                            <Col className="mb-5 mb-xl-0"
                                 xl={this.state.showDayPreview ? `8` :
                                     ((this.state.showClassTypeEditor === true) ? '6' : `12`)}>

                                {isMobile ?
                                    (<WeekSchedule onDaySelected={this.onDaySelected}
                                                   goToClass={this.goToClass}
                                                   openEvent={this.openEvent}
                                                   updateSchedule={this.state.updateSchedule}
                                                   filters={this.state.filters}
                                                   addClass={this.editClassAction}
                                                   handleError={this.handleNetworkError}
                                                   onShiftChange={this.onShiftChange}/>)
                                    :
                                    (<>{this.renderSchedule()}</>)
                                }
                            </Col>
                            {this.state.showDayPreview === true &&
                                <Col xl="4 order-first">
                                    {this.renderDayPreview()}
                                </Col>
                            }
                            {this.state.showClassTypeEditor === true &&
                                <Col xl="6 order-first">

                                    <EditClassTypeView
                                        closeEditClassTypeView={this.closeEditClassTypeView}
                                        classType={resourceHelper.emptyClassType()}
                                        handleError={this.handleNetworkError}
                                    />

                                </Col>
                            }
                            <div ref={(ref) => this.dayViewRef = ref}/>
                        </Row>

                    </Container>
                }
                <div ref={(ref) => this.classTypeViewRef = ref}/>
            </>
        );
    }

    renderSchedule() {
        return localStorage.scheduleView == "week" ?
            <WeekSchedule onDaySelected={this.onDaySelected}
                          goToClass={this.goToClass}
                          openEvent={this.openEvent}
                          updateSchedule={this.state.updateSchedule}
                          filters={this.state.filters}
                          addClass={this.editClassAction}
                          handleError={this.handleNetworkError}
                          onShiftChange={this.onShiftChange}/>
            : <Schedule onDaySelected={this.onDaySelected}
                        goToClass={this.goToClass}
                        openEvent={this.openEvent}
                        updateSchedule={this.state.updateSchedule}
                        filters={this.state.filters}
                        addClass={this.editClassAction}
                        handleError={this.handleNetworkError}
                        onShiftChange={this.onShiftChange}/>
    }

    weekView(e) {
        e.preventDefault();

        localStorage.scheduleView = "week"
        this.setState({viewChanged: !this.state.viewChanged})
    }

    monthView(e) {
        e.preventDefault();
        lsHelpers.updateWeekScheduleShift(0);
        localStorage.scheduleView = "month"
        this.setState({viewChanged: !this.state.viewChanged})
    }

    showWidget(e) {
        e.preventDefault();
        this.setState({shouldShowWidget: !this.state.shouldShowWidget})
    }

    onDaySelected(ev, date) {
        ev.preventDefault();

        const d = new Date(date);
        if (dateHelpers.isValidDate(d)) {
            this.setState({selectedDay: date, showDayPreview: true})
        }
    }

    closeDayPreview(ev) {
        ev.preventDefault();

        this.setState({showDayPreview: false})
    }

    calcShift() {
        return dateHelpers.calculateDayShift(new Date(this.state.selectedDay))
    }

    goToClass(id, from) {
        this.setState({goToClass: true, goToClassId: id})
    }

    openEvent(event) {
        this.setState({showEventModal: true, selectedEvent: event})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    showClassTypes(e) {
        if (e !== null) {
            e.preventDefault();
        }

        this.editClassAction()
    }

    getClassTypes(type) {
        this.setState({isLoading: true});

        ResourceApiService.classTypes()
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false
                });

                if (type === "r") {
                    this.showRegClassesModal()
                } else if (type === "e") this.editClassAction()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    createNewClassType(e) {
        e.preventDefault();

        this.setState({
            showClassTypeEditor: true,
            showClassEditor: false,
            showDayPreview: false,
        });
    }

    // CLASS EDITOR

    editClassAction(e, date = null) {
        if (e) {
            e.preventDefault()
        }
        if (date !== null) {
            try {
                this.setState({selectedDay: new Date(date)})
            }
            catch (e) {
                this.setState({selectedDay: new Date()})
            }
        }

        if (this.state.teachers !== null && this.state.rooms !== null) {
            this.setState({
                showClassEditor: true,
            })
        } else this.getTeachersAndRooms("classes")
    }

    getTeachersAndRooms(target) {
        this.setState({isLoading: true});

        ResourceApiService.teachersAndRooms()
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res[0] || [],
                    rooms: res[1] || [],
                    showClassEditor: target === "classes",
                    showFilters: target === "filters",
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    closeEditClassTypeView() {
        this.setState({
            showClassTypeEditor: false,
        });
        this.getClassTypes("e")
    }

    closeEditClassView(e) {
        if (e) {
            e.preventDefault()
        }

        this.setState({showClassEditor: false, scrollToTop: true, updateSchedule: true, updateDayPreview: true});
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e})
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    showRegClassesModal() {
        (this.state.classTypes === null) ? this.getClassTypes("r") : this.setState({showRegModal: true})
    }

    showEventModal() {
        this.setState({showEventModal: true, selectedEvent: resourceHelper.emptyEvent()})
    }

    showReminderModal() {
        this.setState({showEventModal: true, selectedEvent: resourceHelper.emptyReminder()})
    }

    showFilters() {
        if (this.state.teachers !== null && this.state.rooms !== null) {
            this.setState({showFilters: true})
        } else {
            this.getTeachersAndRooms("filters")
        }
    }

    showCopyClasses() {
        this.setState({showCopyControls: !this.state.showCopyControls})
    }

    toggleClassesModal() {
        this.setState({showRegModal: !this.state.showRegModal})
    }

    toggleEventModal() {
        this.setState({showEventModal: !this.state.showEventModal})
    }

    toggleCopyModal() {
        this.setState({showCopyControls: !this.state.showCopyControls})
    }

    handleClassesAdded() {
        this.setState({showEventModal: false, showRegModal: false, updateSchedule: true})
    }

    reloadSchedule() {
        this.setState({updateSchedule: true})
    }

    onShiftChange(val) {
        this.setState(prevState => {
            return {monthShift: prevState.monthShift + val}
        });
    }

    toggleOneClassModal() {
        this.setState({showClassEditor: !this.state.showClassEditor})
    }

    createClassNewClassType(e) {
        e.preventDefault();

        this.setState({showClassTypeEditor: true, showClassEditor: false, showDayPreview: false})
    }

    renderAddClassPopup(date = this.state.selectedDay) {
        return <AddOneClassModal
            closeEditClassView={this.closeEditClassView}
            teachers={this.state.teachers}
            rooms={this.state.rooms}
            showEditClassType={false}
            toggleModal={this.toggleOneClassModal}
            date={date}
            createClassNewClassType={this.createClassNewClassType}
        />
    }

    renderDayPreview() {
        return <DayPreview shift={this.calcShift()}
                           date={this.state.selectedDay}
                           fromCalendar={true}
                           closeDayPreview={this.closeDayPreview}
                           goToClass={this.goToClass}
                           openEvent={this.openEvent}
                           addClass={this.editClassAction}
                           updateDayPreview={this.state.updateDayPreview}
                           subUser={this.state.subUser}
        />
    }

    toggleFilters() {
        this.setState({showFilters: !this.state.showFilters})
    }

    renderFilterModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showFilters}
                toggle={() => this.toggleFilters("formModal")}
            >
                <div className="modal-header">
                    <h4>{reportStrings.filter}</h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleFilters("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">
                    {this.renderFilters()}
                </div>
            </Modal>
        )
    }

    renderFilters() {
        return <Row>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.teachers}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderTeacherTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.rooms}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderRoomTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
        </Row>
    }

    renderTeacherTable() {
        const selected = (this.state.filters.teachers) ? this.state.filters.teachers.map(it => it.id) : [];
        return (this.state.teachers).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleTeacherSelected.bind(this)}/>
            )
        })
    };

    handleTeacherSelected(checked, id) {
        const tt = this.state.teachers.find(it => it.id === id);
        const selected = ((this.state.filters.teachers) ? this.state.filters.teachers : []);
        const selectedIds = ((this.state.filters.teachers) ? this.state.filters.teachers : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    teachers: selected
                }
            }));
        }
    }

    handleRoomSelected(checked, id) {
        const tt = this.state.rooms.find(it => it.id === id);
        const selected = ((this.state.filters.rooms) ? this.state.filters.rooms : []);
        const selectedIds = ((this.state.filters.rooms) ? this.state.filters.rooms : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    rooms: selected
                }
            }));
        }
    }

    renderRoomTable() {
        const selected = (this.state.filters.rooms) ? this.state.filters.rooms.map(it => it.id) : [];
        return (this.state.rooms).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleRoomSelected.bind(this)}/>
            )
        })
    };
}

export default StudioSchedule;
